<div class="overflow-auto p-5" style="height: 75vh">
  <div class="flex flex-col w-full">
    <div class="inline-block min-w-full pb-2 align-middle">
      <table class="min-w-full" aria-describedby="Lista de Atendentes">
        <thead class="border-b border-gray-400">
          <tr>
            <th
              scope="col"
              class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue"
              style="max-width: 280px"
            >
              Nome
            </th>
            <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">CPF</th>
            <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">CRM</th>
            <th
              scope="col"
              class="px-2 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
              *isAllowed="[ERoleAdminString.Admin, 'doctor.update']"
            >
              Mais
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white hover:bg-iceberg" *ngFor="let doctor of doctors">
            <td class="px-3 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
              {{ doctor.name }}
            </td>
            <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ doctor.document | mask: '000.000.000-00' }}
            </td>
            <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ doctor.crm }}
            </td>
            <td
              class="flex justify-center flex-1 gap-2 px-3 py-4 whitespace-normal text-md text-chathams-blue"
              *isAllowed="[ERoleAdminString.Admin, 'doctor.update']"
            >
              <button
                class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                (click)="abrirEmNovaAba(doctor.id!)"
                title="Editar Atendente"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#000000"
                  width="20"
                  height="20"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-end mb-5">
      <app-paginacao
        [numeroDeItens]="dadosPaginacaoMedicos.itensTotal"
        [tamanhoDaPagina]="dadosPaginacaoMedicos.tamanhoPagina"
        [paginaSelecionada]="dadosPaginacaoMedicos.paginaSelecionada"
        [totalPage]="dadosPaginacaoMedicos.totalPaginas"
        [opcaoItensPagina]="[4, 8]"
        (mudouPagina)="mudouPagina.emit($event)"
        (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
      ></app-paginacao>
    </div>
  </div>

  <app-register-doctor (recarregarListagem)="recarregarListagem.emit()" [companyId]="companyId"></app-register-doctor>
</div>
